import { PaginatedDtoSchema } from "@core/data/dto/paginated.dto.ts";
import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportDetailedStatesRowDtoSchema = z
    .object({
        position: z.string().trim(),
        state: z.string().trim(),
        time: z.number(),
        timestamp: z.number(),
    })
    .readonly();

const ReportStationDetailedStatesDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.array(ReportDetailedStatesRowDtoSchema),
        station: ReportStationSummaryDtoSchema,
        pagination: PaginatedDtoSchema,
    })
    .readonly();

export const ReportDetailedStatesDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationDetailedStatesDtoSchema),
    })
    .readonly();

export type ReportDetailedStatesDto = z.output<
    typeof ReportDetailedStatesDtoSchema
>;
